import type { RootState } from "../../../store";
import type { Company, CurrentCompany, UserState } from "../types/userState.types";

export const selectUser = (state: RootState): UserState => state.userState;

export const selectUserCompanies = (state: RootState): Company[] => state.userState.companies;

export const selectCurrentCompany = (state: RootState): CurrentCompany => state.userState.company;

export const selectActiveCompanyId = (state: RootState): number | string | null =>
  state.userState.activeCompanyId ?? state.userState.company?.id ?? null;

export const selectRole = (state: RootState): string | null => state.userState.company?.role?.type ?? state.userState?.roles?.[0]?.type ?? null;
